<template>
  <div>
    <v-breadcrumbs large :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon size="25">keyboard_arrow_right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-toolbar color="transparent" flat>
      <v-btn flat fab icon @click="back()">
        <v-icon>keyboard_backspace</v-icon>
      </v-btn>
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
          <!-- <v-btn :disabled="btnSave" color="green" outline dark @click="onSubmit()">Save</v-btn>
          <v-btn color="red" outline dark @click="back()">Cancel</v-btn> -->
    </v-toolbar>
    
    <v-divider></v-divider>

    <v-container class="form-container elevation-1">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>

          <v-flex xs12>
              <v-toolbar flat color="transparent">
                  <v-toolbar-title class="grey--text">Add Optional</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>

              <v-dialog v-model="dialog" max-width="500px" persistent>
                  <v-btn color="primary" depressed slot="activator">Add new</v-btn>
                  <v-card style="border-radius: 10px">
                      <v-card-text>
                          <v-container grid-list-md>
                              <v-layout wrap>
                                  <v-flex xs12>
                                       <v-autocomplete
                              dense
                              v-model="selectedOptional"
                              :items="optionals"
                              label="Select Optional"
                              item-text="name"
                              item-value="id"
                              persistent-hint
                              return-object
                              single-line
                              clearable
                              ></v-autocomplete>
                                  </v-flex>
                              </v-layout>
                          </v-container>
                      </v-card-text>
                      <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" flat @click="close()">Cancel</v-btn>
                    <v-btn color="success" flat @click="save()">Save</v-btn>
                  </v-card-actions>
                  </v-card>
              </v-dialog>
              </v-toolbar>

              <v-data-table
              :headers="headers"
              :items="itemAdded"
              :disable-initial-sort="true"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.index + 1 }}</td>
                <td class="text-xs-left">{{ props.item.optionalName }}</td>
                <td class="justify-center">
                  <v-icon color="error" class="ml-3" small @click="deleteItem(props.item)">delete</v-icon>
                </td>
              </template>
            </v-data-table>
          </v-flex>
         
        </v-layout>
        <v-card-actions>
          <v-btn v-if="itemAdded.length > 0" :disabled="btnSave" color="green" dark @click="onSubmit()">Save</v-btn>
          <!-- <v-btn color="primary" dark @click="continues()">Continue</v-btn> -->
          <v-btn color="red" dark @click="back()">Cancel</v-btn>
        </v-card-actions>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      title: "Edit Package Optional",
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,
      dialog: false,

      itemAdded: [],


      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
      },
      valid: true,
      roleType: sessionStorage.roles,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Tour Package",
          disabled: false,
          to: "/tourPackage"
        },
        {
          text: "Edit Package Optional",
          disabled: true,
          to: "/editPackageOptional"
        }
      ],

      optionals: null,
      selectedOptional: null,

      headers: [
        { text: "#", value: "#" },
        { text: "Optional", value: "optionalName" },
        { text: "Remove", value: "remove" }
      ],
      
      form: {}
    };
  },

  mounted() {
      this.axios
        .get(config.API + "Inclusions", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.optionals = res.data.optional;
        });

        this.axios
        .get(config.API + "PackageOptionals/" + this.$route.params.id, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.itemAdded = res.data;
        });
    },

  methods: {
    back() {
      this.$router.go(-1);
    },

    close() {
      this.dialog = false;
    },
    deleteItem(item) {
      const index = this.itemAdded.indexOf(item);
      if(confirm("Are you sure you want to delete this selection?")) {
         this.itemAdded.splice(index, 1);

         this.axios
          .delete(config.API + `PackageOptionals/${item.ids}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            this.$toaster.success("Package Optional deleted successfully");
            //this.getData();
          });
      }
        
    },

    save() {
        if(this.selectedOptional.id != null) {
            let lth = this.itemAdded.length;
            if (lth == 0) {
              this.itemAdded.push({
              optionalId: this.selectedOptional.id,
              optionalName: this.selectedOptional.name
              });

              this.close();
            }
            else {
                let flag = '';

                for(let i = 0; i < lth; i++) {
                    let optional_Id = this.itemAdded[i].optionalId;

                    if(optional_Id == this.selectedOptional.id) {
                        flag = true;
                    }
                }

                if (flag == true) {
                this.$toaster.error(`Already Taken!!`);
               }
               else {
                   this.itemAdded.push({
              optionalId: this.selectedOptional.id,
              optionalName: this.selectedOptional.name
              });

              this.close();
               }
            }
        }
        else {
            this.$toaster.error(`Description is empty!!`);
        }
        
      },


    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        let packageCode = this.$route.params.id;
        this.axios
          .post(
            config.API + `PackageOptionals1`,
            {
              packageCode: packageCode,
              packageOptionals: this.itemAdded
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Package Optional successfully updated");
            //this.$router.push("/createPackageBooking/" + packageCode);
            this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    /* continues() {
        this.$router.push("/createPackageBooking/" + this.$route.params.id);
    } */
  },
};
</script>

<style>
</style>
